module.exports = __webpack_public_path__ + "img/photo_2023-11-22 14.30.31.4c490f0a.jpg";